import { Box } from "@mui/material";
import { MprcCard, MprcLink } from "components";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PublicationViewerDialog } from "views/knowledge/publication/dialogs/PublicationViewerDialog";
import { useCardContext } from "../../CardBuilder";

///
export const ModeratePublicationTitle = () => {

    const { t } = useTranslation("knowledge");
    const { pub: { publicationId, title, blocked } } = useCardContext();

    const [dialog, setDialog] = useState<any>(null);

    return (
        <>
            {dialog}
            <MprcLink
                onClick={
                    () => setDialog(
                        <PublicationViewerDialog
                            publicationId={publicationId}
                            onClose={() => setDialog(null)}
                        />
                    )
                }
            >
                <MprcFeedTypography variant="title" component="div" noWrap={true}>
                    <span title={title}>{title}</span>
                </MprcFeedTypography>
            </MprcLink>

            {blocked?.unblockRequest != null &&
                <Box my={1}>
                    <MprcCard paperColor="notice">
                        <Box sx={{ p: 1 }}>
                            <MprcFeedTypography variant="moreContent" component="p">
                                {t("Feed.Card.ModeratePublications.UnblockRequestText")}
                            </MprcFeedTypography>
                            <MprcFeedTypography variant="stickerLowercase" component="p">
                                {blocked.unblockRequest.message}
                            </MprcFeedTypography>
                        </Box>
                    </MprcCard>
                </Box>
            }
        </>
    );
};
